import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'eos-template-select',
  template: `
  <ng-select [items]="source | async"
    bindLabel="activityHeader"
    [placeholder]="to.placeholder"
    [formControl]="formControl" >

    <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
      <div title="{{item.activityHeader}}"><span>{{ item.activityHeader }}</span></div>
      <div    title="{{item.name}}">
      <span><small>{{item.name}}</small></span></div>
      <div *ngIf="item.immigrationAdditionalInfo && item.immigrationAdditionalInfo.length > 0"  title="{{item.immigrationAdditionalInfo}}">
      <span><small><strong>{{item.immigrationAdditionalInfo}}</strong></small></span></div>
    </ng-template>
  </ng-select>
  `
})
export class TemplateSelectComponent extends FieldType {
  get source(): any {
    return this.to.options;
  }
}
